export default __webpack_public_path__ + "static/media/syllabus-background.ab153644.jpg";